import { useEffect, useState } from "react";
import axios from "axios";
import { ImageIcon } from "lucide-react";
import { API, authHdr } from "./AssociateFields";

const HEX = /^#[0-9A-Fa-f]{6}$/;
const KIN = { p: "#1A3F3A", s: "#C8A96B" };

// Live mini-mock of the associate's login shell: primary → menu, secondary → highlights, plus the uploaded logo.
export const BrandPreview = ({ data, ctx }) => {
  const p = HEX.test(data.primary_color || "") ? data.primary_color : KIN.p;
  const s = HEX.test(data.secondary_color || "") ? data.secondary_color : KIN.s;
  const path = data.logo?.storage_path;
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    if (!path) { setLogo(null); return undefined; }
    let url;
    const base = ctx.token ? `${ctx.publicBase || `${API}/associate-verify/${ctx.token}`}` : `${ctx.base || `${API}/associates/${ctx.id}`}`;
    axios.get(`${base}/files/${path}`, { headers: ctx.token ? {} : authHdr(), responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setLogo(url); }).catch(() => setLogo(null));
    return () => url && URL.revokeObjectURL(url);
  }, [path]); // eslint-disable-line
  const nav = ["Dashboard", "Clients", "Portfolio", "Reports"];
  return (
    <div className="md:col-span-3" data-testid="assoc-brand-preview">
      <p className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-gray-500">Brand preview · what the associate sees on login</p>
      <div className="flex h-56 overflow-hidden rounded-xl border border-gray-200 bg-slate-50 shadow-sm">
        <aside className="flex w-32 shrink-0 sm:w-44 flex-col gap-1.5 p-3" style={{ background: `linear-gradient(180deg, ${p} 0%, color-mix(in srgb, ${p} 40%, black) 100%)` }}>
          <div className="mb-2 flex h-9 items-center">
            {logo ? <span className="flex h-9 max-w-full items-center rounded-md bg-white/95 px-1.5"><img src={logo} alt="logo" className="max-h-full max-w-full object-contain" data-testid="assoc-brand-preview-logo" /></span>
              : <span className="flex items-center gap-1.5"><span className="flex h-7 w-7 items-center justify-center rounded-md text-xs font-bold" style={{ background: s, color: p }}>K</span>
                <span className="text-[10px] tracking-[0.15em] text-white/80">{path ? "LOADING…" : "NO LOGO"}</span></span>}
          </div>
          {nav.map((n, i) => (
            <div key={n} className="rounded-md px-2 py-1.5 text-[11px]"
              style={i === 0 ? { background: `color-mix(in srgb, ${s} 18%, transparent)`, color: s, borderLeft: `2px solid ${s}` } : { color: "rgba(255,255,255,0.65)" }}>{n}</div>))}
        </aside>
        <div className="flex min-w-0 flex-1 flex-col gap-3 p-3 sm:p-4">
          <div className="h-3 w-24 max-w-full rounded bg-slate-300" />
          <div className="grid grid-cols-3 gap-2">{[0, 1, 2].map((i) => <div key={i} className="h-14 rounded-lg border border-slate-200 bg-white" />)}</div>
          <div className="flex-1 rounded-lg border border-slate-200 bg-white" />
          <div className="flex flex-wrap gap-2">
            <span className="rounded-md px-3 py-1.5 text-[11px] font-medium text-white" style={{ background: p }}>Primary button</span>
            <span className="rounded-full px-2.5 py-1.5 text-[11px] font-semibold" style={{ background: s, color: p }}>Highlight</span>
            {!path && <span className="ml-auto flex items-center gap-1 text-[11px] text-slate-400"><ImageIcon className="h-3 w-3" />Upload a logo to see it here</span>}
          </div>
        </div>
      </div>
    </div>
  );
};
